import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/pages/base/base.component';
import { HeaderService } from 'src/app/services/_app/header/header.service';
import { SchemaDriftService } from 'src/app/services/_app/schema-drift/schema-drift.service';
import { ITableDriftSummaryDto } from '../../../../../models/features/schema-drift/ITableDriftSummaryDto';
import { AuditProfileService } from '../../../../../services/audit-profile/audit-profile.service';

@Component({
  selector: 'app-schema-drift-dashboard',
  templateUrl: './schema-drift-dashboard.component.html',
  styleUrls: ['./schema-drift-dashboard.component.css']
})
export class SchemaDriftDashboardComponent extends BaseComponent implements OnInit, AfterViewInit {
  // *********************
  // variables declaration
  // *********************

  // private
  // ********


  // public
  // ******
  // TODO: Make private variables if they are used only within the component
  public driftDataSummary: any = {};
  public parsedDriftData: any[] = [];
  public tableSummary: ITableDriftSummaryDto[] = [];
  public totalAdded = 0;
  public totalArchived = 0;
  public totalRemoved = 0;
  public databaseName: string = '...';
  public skeleton: boolean = true;
  public sortedColumn: keyof ITableDriftSummaryDto | '' = '';
  public sortAscending: boolean = true;
  public isGridShow: boolean = true;
  public all: boolean = false;
  public isPreviewDataSelected: boolean = false;
  public stabilityIndex: number = 100;

  constructor(private auditProfileService: AuditProfileService,
    private headerService: HeaderService,
    private schemaDriftService: SchemaDriftService,
    private router: Router) {
    super();
  }

  // ***************
  // lifecycle hooks
  // ***************
  override async ngOnInit() {
    await this.housekeeping();
  }

  ngAfterViewInit(): void {
  }

  // *******
  // methods
  // *******

  // public
  // ******
  public showTableData(tableName: ITableDriftSummaryDto) {
    //this.PreviewDataTableSchema = record.tableSchema;
    //this.PreviewDataTableName = record.tableName;
    this.isPreviewDataSelected = true;
    // get from LighthouseDashboardComponent
  }

  public sortByColumn(columnName: keyof ITableDriftSummaryDto): void {
    const isSameColumn = this.sortedColumn === columnName;
    this.sortAscending = isSameColumn ? !this.sortAscending : true;
    this.sortedColumn = columnName;

    const getComparableValue = (row: ITableDriftSummaryDto): number | string => {
      const value = row[columnName] as any;

      if (columnName === 'lastChangeDate') {
        if (!value) return 0;

        const time = value instanceof Date ? value.getTime() : new Date(value).getTime();

        return isNaN(time) ? 0 : time;
      }

      return value ?? '';
    };

    this.tableSummary.sort((a, b) => {
      const av = getComparableValue(a);
      const bv = getComparableValue(b);

      if (typeof av === 'number' && typeof bv === 'number') {
        const result = av - bv;

        return this.sortAscending ? result : -result;
      }

      const result = String(av).localeCompare(String(bv), undefined, { numeric: true, sensitivity: 'base' });

      return this.sortAscending ? result : -result;
    });
  }

  public exportCSV() {

  }

  public close(event: boolean) {
    this.isPreviewDataSelected = false;
  }

  // private
  // *******
  private async housekeeping() {
    const auditProfileId = this.AuditProfileId as string;
    
    await this.auditProfileService.getAuditProfileSyncsAsync(auditProfileId).then(async (x: any) => {
      const databaseSchemaDrift = x;
      const parsedDrift = this.schemaDriftService.parseSchemaDrift(databaseSchemaDrift);

      this.parsedDriftData = parsedDrift;

      console.log(databaseSchemaDrift);
      console.log(parsedDrift);

      if (parsedDrift.length > 0) {
        let a = this.schemaDriftService.summarizeByTable(parsedDrift);

        a.map((x) => {
          x.isSelected = false;

          return x;
        });

        const isRemoveArchivedTables = false;

        if (isRemoveArchivedTables) {
          this.tableSummary = a.filter(x => x.table.indexOf('ssk_Audit_') < 0);

          this.totalAdded = parsedDrift.filter(p => p.action === 'Added' && p.table.indexOf('ssk_Audit_') < 0).length;
          this.totalArchived = parsedDrift.filter(p => p.action === 'Archived' && p.table.indexOf('ssk_Audit_') < 0).length;
          this.totalRemoved = parsedDrift.filter(p => p.action === 'Removed' && p.table.indexOf('ssk_Audit_') < 0).length;
        } else {
          this.tableSummary = a;

          this.totalAdded = parsedDrift.filter(p => p.action === 'Added').length;
          this.totalArchived = parsedDrift.filter(p => p.action === 'Archived').length;
          this.totalRemoved = parsedDrift.filter(p => p.action === 'Removed').length;
        }

        const _ = {
          TableDriftSummary: a,
          FilteredTableDriftSummary: this.tableSummary,
          ParsedDrift: parsedDrift,
          TotalAdded: this.totalAdded,
          TotalArchived: this.totalArchived,
          TotalRemoved: this.totalRemoved
        };

        this.driftDataSummary = _;

        await this.auditProfileService.getAuditProfileNumberOfTablesAsync(auditProfileId).then((x: any) => {
          // TODO: Write an API endpoint to get the number of tables for a database
          this.stabilityIndex = this.schemaDriftService.computeStabilityIndex(this.tableSummary, x.TableCount);
        }).catch((err: any) => {

        });
        

        this.skeleton = false;
      } else {
        this.isGridShow = false;
      }

    }).catch((err: any) => {

    });
  }

}
